export const selectMoodState = state => state.mood;
export const selectMoodTags = state => state.mood.tags;
export const selectMoodWeekInterval = state => state.mood.week;
